import { FC } from 'react';
import { RouteRedirect } from 'modules/routing-module';

export const Playlists: FC = () => <RouteRedirect routeKey="PlaylistsList" />;
